webpackJsonp([1],Array(23).concat([
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(130);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66dff73a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(78);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66dff73a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ControlPanel__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ToggleAlert__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DebugWindow__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    DebugWindow: __WEBPACK_IMPORTED_MODULE_2__components_DebugWindow__["a" /* default */],
    ControlPanel: __WEBPACK_IMPORTED_MODULE_0__components_ControlPanel__["a" /* default */],
    ToggleAlert: __WEBPACK_IMPORTED_MODULE_1__components_ToggleAlert__["a" /* default */]
  },

  computed: {
    isAutostartOn: function isAutostartOn() {
      return this.$store ? this.$store.getters.isAutostartOn : false;
    },
    soundIsOn: function soundIsOn() {
      return this.$store ? this.$store.state.soundIsOn : false;
    }
  },
  watch: {
    isAutostartOn: function isAutostartOn(data) {
      this.setURL();
    },
    soundIsOn: function soundIsOn(data) {
      this.setURL();
    }
  },

  methods: {
    setURL: function setURL() {
      // Ref: https://router.vuejs.org/en/essentials/navigation.html
      this.$router.push({
        path: '/',
        query: {
          autonext: this.isAutostartOn ? 'on' : 'off',
          autostart: this.$route.query.autostart === 'on' ? 'on' : 'off',
          sound: this.soundIsOn ? 'on' : 'off'
        }
      });
    }
  },

  beforeMount: function beforeMount() {
    // Change only if different from default, check defaults in /store/index.js
    if (this.$route.query.sound === 'off') {
      this.$store.commit('toggleSound');
    }
    if (this.$route.query.autonext === 'on') {
      this.$store.commit('toggleAutostart');
    }
    if (this.$route.query.autostart === 'on') {
      this.$store.commit('toggleTimer');
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Should be turn off for productions
    // this.$store.commit('turnOnTestingParameters')

    this.intervalName = setInterval(function () {
      if (_this.$store.getters.isTimerOn) _this.$store.commit('updateTimer');
      if (_this.$store.getters.isTimerOn && _this.$store.getters.isIntervalCompleted) {
        _this.$store.commit('initiateNextInterval');
      }
      // this.$store.state.playSound = !this.$store.state.playSound // Testing only
    }, 1000);
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPanel_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cff9f09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPanel_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cff9f09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cff9f09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // PascalCase, e.g. ThisIsAnExample
  name: 'ControlPanel',

  // variables
  data: function data() {
    return {};
  },

  computed: {
    autostartNextInterval: function autostartNextInterval() {
      return this.$store && this.$store.state.autostartNextInterval;
    },
    autostartButtonTitle: function autostartButtonTitle() {
      return 'Autostart Next Interval is ' + (this.autostartNextInterval ? 'ON' : 'OFF');
    },
    autostartIcon: function autostartIcon() {
      var SVG_AUTOSTART_ON = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<polyline points="23 4 23 10 17 10"></polyline> ' + '<polyline points="1 20 1 14 7 14"></polyline> ' + '<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path> ' + '</svg>';
      var SVG_AUTOSTART_OFF = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<line x1="1" y1="1" x2="23" y2="23" class=""></line> ' + '<polyline points="23 4 23 10 17 10"></polyline> ' + '<polyline points="1 20 1 14 7 14"></polyline> ' + '<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path> ' + '</svg>';
      return this.autostartNextInterval ? SVG_AUTOSTART_ON : SVG_AUTOSTART_OFF;
    },
    soundIsOn: function soundIsOn() {
      return this.$store && this.$store.state.soundIsOn;
    },
    soundButtonTitle: function soundButtonTitle() {
      return 'Sound is ' + (this.soundIsOn ? 'ON' : 'OFF');
    },
    soundIcon: function soundIcon() {
      var SVG_SOUND_OFF = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<path d="M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z" /> ' + '</svg>';
      var SVG_SOUND_ON = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<path d="M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z M21 2 C21 2 25 6 25 16 25 26 21 30 21 30 M27 4 C27 4 30 8 30 16 30 24 27 28 27 28" /> ' + '</svg>';
      return this.soundIsOn ? SVG_SOUND_ON : SVG_SOUND_OFF;
    }
  },
  methods: {
    clickAutostart: function clickAutostart() {
      this.$store.commit('toggleAutostart');
    },
    clickShowLog: function clickShowLog() {
      this.$store.commit('openLog');
    },
    clickSound: function clickSound() {
      this.$store.commit('toggleSound');
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 align-self-center text-right pr-0"},[_c('button',{staticClass:"btn btn-link",attrs:{"title":"Show Log"},on:{"click":_vm.clickShowLog}},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('line',{attrs:{"x1":"8","y1":"6","x2":"21","y2":"6"}}),_vm._v(" "),_c('line',{attrs:{"x1":"8","y1":"12","x2":"21","y2":"12"}}),_vm._v(" "),_c('line',{attrs:{"x1":"8","y1":"18","x2":"21","y2":"18"}}),_vm._v(" "),_c('line',{attrs:{"x1":"3","y1":"6","x2":"3","y2":"6"}}),_vm._v(" "),_c('line',{attrs:{"x1":"3","y1":"12","x2":"3","y2":"12"}}),_vm._v(" "),_c('line',{attrs:{"x1":"3","y1":"18","x2":"3","y2":"18"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-link",attrs:{"title":_vm.autostartButtonTitle},domProps:{"innerHTML":_vm._s(_vm.autostartIcon)},on:{"click":_vm.clickAutostart}}),_vm._v(" "),_c('button',{staticClass:"btn btn-link",attrs:{"title":_vm.soundButtonTitle},domProps:{"innerHTML":_vm._s(_vm.soundIcon)},on:{"click":_vm.clickSound}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleAlert_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79dbd70c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleAlert_vue__ = __webpack_require__(73);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79dbd70c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue_es_components_modal_modal__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Ref: https://bootstrap-vue.js.org/docs/components/alert
// import bAlert from 'bootstrap-vue/es/components/alert/alert'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ToggleAlert',
  components: {
    bModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue_es_components_modal_modal__["a" /* default */]
  },

  // variables
  data: function data() {
    return {
      alertMessage: 'Autostart Next Interval is OFF',
      showAlert: false,
      bodyTextVariant: 'dark'
    };
  },

  computed: {
    isAutostartOn: function isAutostartOn() {
      return this.$store ? this.$store.getters.isAutostartOn : false;
    },
    soundIsOn: function soundIsOn() {
      return this.$store ? this.$store.state.soundIsOn : false;
    }
  },
  watch: {
    isAutostartOn: function isAutostartOn(data) {
      this.alertMessage = 'Autostart Next Interval is <span class="badge badge-' + (this.isAutostartOn ? 'success">On' : 'danger">Off') + '</span>';
      this.showAlert = true;
    },
    soundIsOn: function soundIsOn(data) {
      this.alertMessage = 'Sound is <span class="badge badge-' + (this.soundIsOn ? 'success">On' : 'danger">Off') + '</span>';
      this.showAlert = true;
    },
    showAlert: function showAlert(data) {
      var _this = this;

      if (data === true) {
        // Autoclose alert
        setTimeout(function () {
          _this.showAlert = false;
        }, 1000);
      }
    }
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(40);
function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('b-modal',{staticClass:"text-center",attrs:{"title":"Sound is ON","hide-footer":true,"hide-header":true,"body-text-variant":_vm.bodyTextVariant,"size":"sm"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_c('div',{staticClass:"timer-alert",domProps:{"innerHTML":_vm._s(_vm.alertMessage)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DebugWindow_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b97ad2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DebugWindow_vue__ = __webpack_require__(77);
function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b97ad2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DebugWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b97ad2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DebugWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Debug information for the DOM
 *
 * @param  {Boolean} show
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // PascalCase, e.g. ThisIsAnExample
  name: 'DebugWindow',

  // component properties/variables
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },

  // variables
  data: function data() {
    return {
      hide: false,
      properties: []
    };
  },


  // component Lifecycle hooks
  mounted: function mounted() {
    var _this = this;

    this.hide = !this.show;
    this.setData();
    window.addEventListener('resize', function () {
      _this.setData();
    });
    window.addEventListener('scroll', function () {
      _this.setData();
    });
  },


  // methods
  methods: {
    addToProperties: function addToProperties(id) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.properties.push({ id: id, value: value });
    },
    displayProperty: function displayProperty(id, value) {
      if (id === 'break') {
        return '<br>';
      } else {
        return '\u2022 ' + id + ': ' + value + ' &nbsp; &nbsp;';
      }
    },
    setData: function setData() {
      this.properties = [];
      this.addToProperties('[body] clientHeight', document.body.clientHeight);
      this.addToProperties('[documentElement] documentElement.clientHeight', document.documentElement.clientHeight);
      this.addToProperties('[body] scrollHeight', document.body.scrollHeight);
      this.addToProperties('[documentElement] scrollHeight', document.documentElement.scrollHeight);
      this.addToProperties('[window] innerHeight', window.innerHeight);
      this.addToProperties('[window] scrollY', window.scrollY);
      this.addToProperties('break');
      this.addToProperties('[body] clientWidth', document.body.clientWidth);
      this.addToProperties('[documentElement] documentElement.clientWidth', document.documentElement.clientWidth);
      this.addToProperties('[body] scrollWidth', document.body.scrollWidth);
      this.addToProperties('[documentElement] scrollWidth', document.documentElement.scrollWidth);
      this.addToProperties('[window] innerWidth', window.innerWidth);
      // console.table(this.properties)
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('div',{staticClass:"debug-window"},[_c('button',{on:{"click":function($event){_vm.hide = true}}},[_vm._v("×")]),_vm._v("\n  IMPORTANT: This is suitable for development purpose only"),_c('br'),_vm._v(" "),_vm._l((_vm.properties),function(property,index){return _c('span',{key:index,domProps:{"innerHTML":_vm._s(_vm.displayProperty(property.id, property.value))}})})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('header',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('control-panel')],1),_vm._v(" "),_c('toggle-alert'),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(1,false,false)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"col-6 pt-2"},[_vm._v("Pomodoro"),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(" Timer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    Proudly brought to you by "),_c('a',{attrs:{"href":"https://aiwebstudio.com","target":"_blank"}},[_vm._v("Active Improvement Web Studio")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(81);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }]
}));

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abac4e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0abac4e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abac4e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer__ = __webpack_require__(84);
//
//
//
//
//
//

// import { mapState } from 'vuex'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_0__Timer__["a" /* default */]
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610cbe63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-610cbe63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610cbe63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimerButton__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimerLog__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimerSound__ = __webpack_require__(123);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  // PascalCase, e.g. ThisIsAnExample
  name: 'Timer',
  components: {
    TimerButton: __WEBPACK_IMPORTED_MODULE_0__TimerButton__["a" /* default */],
    TimerLog: __WEBPACK_IMPORTED_MODULE_1__TimerLog__["a" /* default */],
    TimerSound: __WEBPACK_IMPORTED_MODULE_2__TimerSound__["a" /* default */]
  },

  // variables
  data: function data() {
    return {
      intervalName: ''
    };
  },

  computed: {
    displayTimer: function displayTimer() {
      // Without testing this.$store an error will be generated during unit test
      if (this.$store) {
        var minutes = Math.floor(this.$store.state.timer / 60);
        var seconds = this.$store.state.timer - minutes * 60;
        // Pad 0
        minutes = ('0' + minutes).slice(-2);
        seconds = ('0' + seconds).slice(-2);

        return minutes + ':' + seconds;
      }
    },
    isOnBreak: function isOnBreak() {
      if (this.$store) {
        return !(this.$store.state.pomodoroIntervals[this.$store.state.currentIntervalIndex].name === 'Pomodoro');
      } else {
        return false;
      }
    }
  },
  methods: {
    click: function click() {
      this.$store.commit('toggleTimer');
    }
  }

});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerButton_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308648bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerButton_vue__ = __webpack_require__(90);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-308648bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308648bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // PascalCase, e.g. ThisIsAnExample
  name: 'TimerButton',

  // variables
  data: function data() {
    return {};
  },

  methods: {
    buttonText: function buttonText() {
      var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$store;

      // Note: converted from computed to methods to allow store to be injected for unit testing purpose
      var text = '...';
      var currentIntervalIndex = store ? store.state.currentIntervalIndex : 0;
      var pomodoroIntervals = store ? store.state.pomodoroIntervals : [];
      var intervalName = store ? pomodoroIntervals[currentIntervalIndex].name : [];
      var svg = false;

      var SVG_PLAY = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<polygon points="5 3 19 12 5 21 5 3"></polygon> ' + '</svg>';
      var SVG_PAUSE = '<svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<rect x="6" y="4" width="4" height="16"></rect> ' + '<rect x="14" y="4" width="4" height="16"></rect> ' + '</svg>';
      // const SVG_CHECK_CIRCLE = '<svg width="16" height="16" viewBox="0 0 23 23" fill="none" stroke="currentColor" stroke-width="2" ' +
      //                          'stroke-linecap="round" stroke-linejoin="round"> ' +
      //                          '<path d="M22 11.07V12a10 10 0 1 1-5.93-9.14"></path> ' +
      //                          '<polyline points="23 3 12 14 9 11"></polyline> ' +
      //                          '</svg>'
      var SVG_CHECK_SQUARE = '<svg width="17" height="17" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2" ' + 'stroke-linecap="round" stroke-linejoin="round"> ' + '<polyline points="9 11 12 14 23 3"></polyline> ' + '<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path> ' + '</svg>';

      if (store) {
        if (store.getters.isIntervalCompleted) {
          text = intervalName + ' is completed';
          svg = SVG_CHECK_SQUARE;
        } else if (store.getters.isTimerOn) {
          text = 'Pause ' + intervalName;
          svg = SVG_PAUSE;
        } else if (store.state.timer < pomodoroIntervals[currentIntervalIndex].time) {
          text = 'Resume ' + intervalName;
          svg = SVG_PLAY;
        } else {
          text = 'Start ' + intervalName;
          svg = SVG_PLAY;
        }
        if (svg) {
          text = svg + ' &nbsp;' + text;
        }
      }
      return text;
    },
    click: function click() {
      this.$store.commit('toggleTimer');
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-10 col-md-8 mx-auto"},[_c('button',{staticClass:"btn btn-lg btn-block",class:{
      'btn-success': this.$store && !this.$store.getters.isTimerOn && !this.$store.getters.isIntervalCompleted,
      'btn-light': this.$store && !this.$store.getters.isTimerOn && this.$store.getters.isIntervalCompleted,
      'btn-warning': this.$store && this.$store.getters.isTimerOn
    },attrs:{"disabled":this.$store && !this.$store.getters.isTimerOn && this.$store.getters.isIntervalCompleted},domProps:{"innerHTML":_vm._s(_vm.buttonText())},on:{"click":_vm.click}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerLog_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bea25a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerLog_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bea25a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bea25a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_modal_modal__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Ref: https://bootstrap-vue.js.org/docs/components/modal


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TimerLog',
  components: {
    bModal: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_modal_modal__["a" /* default */]
  },

  // variables
  data: function data() {
    return {
      log: [],
      modelShow: false,
      headerBgVariant: 'light',
      headerTextVariant: 'dark',
      bodyTextVariant: 'dark'
    };
  },

  computed: {
    currentIntervalIndex: function currentIntervalIndex() {
      return this.$store ? this.$store.state.currentIntervalIndex : 0;
    },
    isTimerOn: function isTimerOn() {
      return this.$store ? this.$store.getters.isTimerOn : false;
    },

    showLog: {
      // getter
      get: function get() {
        return this.$store ? this.$store.state.showLog : false;
      },
      // setter
      set: function set(value) {
        this.$store.state.showLog = value;
      }
    }
  },
  watch: {
    currentIntervalIndex: function currentIntervalIndex(data) {
      // Set end time
      this.log[0].endTime = new Date().toLocaleTimeString();

      // New log entry at the FRONT of the array
      this.addToLog(data);
    },
    isTimerOn: function isTimerOn(data) {
      if (data === true && this.log[0].startTime === 0) {
        // Timer is on and start time has not been set
        // Scenario #1: When app first started
        // Scenario #2: Autostart Next Interval is off, user clicks on Start
        this.log[0].startTime = new Date().toLocaleTimeString();
      }
    }
  },
  methods: {
    addToLog: function addToLog(intervalIndex) {
      if (this.$store) {
        // Note: New log entry is added to the FRONT of the array
        this.log.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          startTime: this.isTimerOn ? new Date().toLocaleTimeString() : 0,
          endTime: 0
        }, this.$store.state.pomodoroIntervals[intervalIndex]));
      }
    }
  },
  mounted: function mounted() {
    this.addToLog(0);
  }
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"title":"Log","hide-footer":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant,"body-text-variant":_vm.bodyTextVariant,"busy":true},model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('table',{staticClass:"table table-bordered table-sm"},[_c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',[_vm._v("Interval")]),_vm._v(" "),_c('th',[_vm._v("Start Time")]),_vm._v(" "),_c('th',[_vm._v("End Time")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.log),function(logItem,index){return _c('tr',{key:index,class:{ "table-success": logItem.name === "Pomodoro" }},[_c('td',[_vm._v(_vm._s(logItem.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(isNaN(logItem.startTime) ? logItem.startTime : '...'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(isNaN(logItem.endTime) ? logItem.endTime : '...'))])])}))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerSound_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61abcb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerSound_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61abcb76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimerSound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61abcb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimerSound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // PascalCase, e.g. ThisIsAnExample
  name: 'TimerSound',

  // variables
  data: function data() {
    return {};
  },

  computed: {
    playSound: function playSound() {
      return this.$store ? this.$store.state.playSound : false;
    },
    soundIsOn: function soundIsOn() {
      return this.$store ? this.$store.state.soundIsOn : false;
    }
  },
  watch: {
    playSound: function playSound(data) {
      if (data === true) {
        this.$store.commit('soundHasBeenPlayed');
        if (this.$store.state.soundIsOn) document.getElementById('timer-sound').play();
      }
    },
    soundIsOn: function soundIsOn(data) {
      if (data === false) {
        // Stop sound that could potential be playing
        this.$store.commit('soundHasBeenPlayed');
        document.getElementById('timer-sound').pause();
        document.getElementById('timer-sound').currentTime = 0;
      }
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"id":"timer-sound"}},[_c('source',{attrs:{"src":__webpack_require__(127),"type":"audio/wav"}}),_vm._v("\n    Your browser does not support the audio element.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3beeps.b1a1620.wav";

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"timer text-center"},[_c('div',{class:{
      'invisible': this.$store && !this.$store.state.showTimer,
      'text-break': this.isOnBreak
      },on:{"click":_vm.click}},[_vm._v("\n      "+_vm._s(_vm.displayTimer)+"\n    ")]),_vm._v(" "),_c('timer-button')],1),_vm._v(" "),_c('timer-sound'),_vm._v(" "),_c('timer-log')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello row align-items-center"},[_c('timer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(133);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// time is in seconds
var POMODORO = { name: 'Pomodoro', time: 25 * 60 };
var SHORT_BREAK = { name: 'Short Break', time: 5 * 60 };
var LONG_BREAK = { name: 'Long Break', time: 20 * 60 };
var POMODORO_INTERVALS = [POMODORO, SHORT_BREAK, POMODORO, SHORT_BREAK, POMODORO, SHORT_BREAK, POMODORO, LONG_BREAK];

var state = {
  autostartNextInterval: false,
  currentIntervalIndex: 0,
  playSound: false,
  pomodoroIntervals: POMODORO_INTERVALS,
  showLog: false,
  showTimer: true,
  soundIsOn: true,
  timer: POMODORO_INTERVALS[0].time,
  timerIsOn: false
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__
}));

/***/ }),
/* 131 */,
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAutostartOn", function() { return isAutostartOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTimerOn", function() { return isTimerOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIntervalCompleted", function() { return isIntervalCompleted; });
var isAutostartOn = function isAutostartOn(state) {
  return state.autostartNextInterval;
};

var isTimerOn = function isTimerOn(state) {
  return state.timerIsOn;
};

var isIntervalCompleted = function isIntervalCompleted(state) {
  return state.timer === 0;
};

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAutostart", function() { return toggleAutostart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSound", function() { return toggleSound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleTimer", function() { return toggleTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "soundHasBeenPlayed", function() { return soundHasBeenPlayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTimer", function() { return updateTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openLog", function() { return openLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initiateNextInterval", function() { return initiateNextInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turnOnTestingParameters", function() { return turnOnTestingParameters; });
var toggleAutostart = function toggleAutostart(state) {
  state.autostartNextInterval = !state.autostartNextInterval;
};

var toggleSound = function toggleSound(state) {
  state.soundIsOn = !state.soundIsOn;
};

var toggleTimer = function toggleTimer(state) {
  state.timerIsOn = !state.timerIsOn;
};

var soundHasBeenPlayed = function soundHasBeenPlayed(state) {
  state.playSound = false;
};

var updateTimer = function updateTimer(state) {
  if (state.timer > 0) state.timer--;
};

var openLog = function openLog(state) {
  state.showLog = true;
};

// Previous interval is over, play sound, flash counter, and set timer to next interval
var initiateNextInterval = function initiateNextInterval(state) {
  if (state.timerIsOn) {
    // Prevent repeat executions
    state.timerIsOn = false;

    // Blink counter
    var blinkTimer = setInterval(function () {
      state.showTimer = !state.showTimer;
    }, 350);

    // Play sound
    state.playSound = true;

    // Initialize next interval settings after a short timeout
    setTimeout(function () {
      // Stop timer from blinking
      clearInterval(blinkTimer);
      state.showTimer = true;

      // Increment current interval index, loop if necessary
      state.currentIntervalIndex = ++state.currentIntervalIndex % state.pomodoroIntervals.length;
      // Reset timer
      state.timer = state.pomodoroIntervals[state.currentIntervalIndex].time;
      // If autostart is on, turn on timer
      if (state.autostartNextInterval) state.timerIsOn = true;
    }, 3000);
  }
};

/* ------------------------
   Developer Only functions
   ------------------------ */
var turnOnTestingParameters = function turnOnTestingParameters(state) {
  state.pomodoroIntervals = state.pomodoroIntervals.map(function (interval) {
    interval.time = 5;
    return interval;
  });
  state.timer = state.pomodoroIntervals[0].time;
  // state.autostartNextInterval = true
};

/***/ })
]),[23]);


// WEBPACK FOOTER //
// static/js/app.5a370d7cf762c1a8fe50.js